import React from "react";

import { SwiperCarousel } from "supercell-frontend-base/src/components/swiper-carousel";
import { CarouselSlide } from "supercell-frontend-base/src/components/swiper-carousel/slide";
import { Grid } from "supercell-frontend-base/src/components/grid";
import { List } from "supercell-frontend-base/src/components/list";
import { ListArticle } from "supercell-frontend-base/src/components/list/article";
import { ContentfulSocialLinks } from "supercell-frontend-base/src/components/contentful-social-links";
import { Tab } from "supercell-frontend-base/src/components/inbox/tab";
import { FullscreenEntryContainer } from "supercell-frontend-base/src/components/fullscreen-entry";

import { filterNewsFeed } from "supercell-frontend-base/src/utils/filter-news-feed";
import { filterEntry } from "supercell-frontend-base/src/targeting/targeting";
import { BrawlStarsGameParams } from "../../validation/game-params";
import { useGameParamsContext } from "supercell-frontend-base/src/stores/gameParams";

import styles from "./styles.modules.scss";

export const NewsView = () => (
    <Tab namespace="news">
        {({ data, locale }) => {
            const { gameParams } = useGameParamsContext<BrawlStarsGameParams>();

            const filterArticles = (a: any) =>
                filterNewsFeed(a) &&
                filterEntry(a, gameParams as BrawlStarsGameParams);

            return (
                <FullscreenEntryContainer
                    entries={(data as any).fullscreenEntries.filter((e: any) =>
                        filterEntry(e, gameParams as BrawlStarsGameParams),
                    )}
                    tab="news"
                >
                    <div className={`news ${styles.news}`}>
                        <Grid>
                            {(data as any).events ? (
                                <div className={`events ${styles.events}`}>
                                    <SwiperCarousel
                                        locale={locale}
                                        Slide={CarouselSlide}
                                        slides={(data as any).events.filter(
                                            (e: any) =>
                                                filterEntry(
                                                    e,
                                                    gameParams as BrawlStarsGameParams,
                                                ),
                                        )}
                                    />
                                </div>
                            ) : null}

                            {(data as any).articles ? (
                                <div className={`articles ${styles.articles}`}>
                                    <List
                                        perPage={5}
                                        Item={ListArticle}
                                        items={(data as any).articles.filter(
                                            (e: any) => filterArticles(e),
                                        )}
                                        footer={
                                            <ContentfulSocialLinks
                                                links={
                                                    (data as any).socialLinks
                                                }
                                            />
                                        }
                                    />
                                </div>
                            ) : null}
                        </Grid>
                    </div>
                </FullscreenEntryContainer>
            );
        }}
    </Tab>
);
